import { FC } from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';

interface Content {
  title?: string;
  text: string;
}

interface TechnologiesToolsProps {
  contents: Array<Content>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(4),
  },
  textBlock: {
    marginTop: theme.spacing(2),
    '& span': {
      fontWeight: 700,
    },
  },
}));

const TechnologiesTools: FC<TechnologiesToolsProps> = ({ contents }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {contents.map(({ title, text }, index) => (
        <ul key={index}>
          <li>
            <Typography variant="body2" className={classes.textBlock}>
              {title}
              <Typography component="span" color="primary">
                {text}
              </Typography>
            </Typography>
          </li>
        </ul>
      ))}
    </div>
  );
};

export default TechnologiesTools;
